import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '@/views/Login.vue';

// Management
import matriz from './modules/management/matriz';
import rates from './modules/management/rates';
import accordance from './modules/management/accordance';
import promoters from './modules/management/promoters';
import typists from './modules/management/typists';
import corban from './modules/management/corban';
import hub from './modules/management/hub';
import featureAccess from './modules/management/featureAccess';

// Services
import fgts from './modules/services/fgts';
import workerCredit from './modules/services/workerCredit';
import creditCard from './modules/services/creditCard';
import inss from './modules/services/inss';
import videoCall from './modules/services/videoCall';
import livelo from './modules/services/livelo';
import cgv from './modules/services/cgv';

import { shouldChangePassword } from './middlewares/passwordValidation';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  routes: [
    ...matriz,
    ...rates,
    ...accordance,
    ...promoters,
    ...typists,
    ...corban,
    ...fgts,
    ...workerCredit,
    ...creditCard,
    ...inss,
    ...videoCall,
    ...livelo,
    ...cgv,
    ...hub,
    ...featureAccess,
    { path: '*', component: Login },
  ],
});

router.beforeEach((to, from, next) => {
  shouldChangePassword(to, from, next);
});

export default router;
